import { render, staticRenderFns } from "./CapitalText.vue?vue&type=template&id=7d6bb8ef&scoped=true&"
import script from "./CapitalText.vue?vue&type=script&lang=js&"
export * from "./CapitalText.vue?vue&type=script&lang=js&"
import style0 from "./CapitalText.vue?vue&type=style&index=0&id=7d6bb8ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6bb8ef",
  null
  
)

export default component.exports